export const mutations = {
  RESET: 'RESET',
  TOGGLE_OVERLAY: 'TOGGLE_OVERLAY',
  ALERT: 'alert',
};

export const actions = {
  GET_SHOP_INFO: 'getShopInfo',
  GET_PAGE_INFO: 'getPageInfo',
};

export const alert = {
  title: '',
  message: '',
  typeAlert: '',
  show: false,
  hideCloseIcon: false,
};
